import { BrowserRouter,Route,Routes } from 'react-router-dom';
import Header from "./Components/Header";
import Home from './Pages/Home';
import Blog from './Pages/Blog';
import Album from './Pages/Album';
import Promo from './Pages/Promo';
import Article from './Pages/Article';
import ReactGA from "react-ga4";
const track_id="G-6L35N8T6ZT";
function App() {
  ReactGA.initialize(track_id);

  return (
    <div className="App">
 <BrowserRouter>
      <Header/>
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path='/معرض الصور' element={<Album/>}/>
      <Route path='/العروض' element={<Promo/>}/>
      <Route path='/الخدمات' element={<Blog/>}/>
      <Route path="/الخدمات/:name" element={<Article/>}/>
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
